import { render } from "./MySubscriptions.vue?vue&type=template&id=3cf87b8f&scoped=true"
import script from "./MySubscriptions.vue?vue&type=script&lang=js"
export * from "./MySubscriptions.vue?vue&type=script&lang=js"

import "./MySubscriptions.vue?vue&type=style&index=0&id=3cf87b8f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf87b8f"]])

export default __exports__